window.ppRunWhenIdle = window.ppRunWhenIdle || function (callback, timeout) {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(function () {
      callback();
    }, { timeout: timeout || 1800 });
    return;
  }

  window.setTimeout(callback, Math.min(timeout || 1800, 300));
};

(function () {
  function triggerQuickAdd(button) {
    const card = button.closest('.product-card__content, .resource-card, .section-resource-list__item, .product-grid__item') || button.parentElement;
    const quickAddButton = card?.querySelector('quick-add-component .quick-add__button--choose');
    const directAddButton = card?.querySelector('quick-add-component .quick-add__button--add:not([disabled])');
    const quickAddForm = card?.querySelector('quick-add-component product-form-component form');

    if (quickAddButton) {
      quickAddButton.click();
      return;
    }

    if (directAddButton) {
      directAddButton.click();
      return;
    }

    if (quickAddForm?.requestSubmit) {
      quickAddForm.requestSubmit();
    }
  }

  document.addEventListener('click', function (event) {
    const addButton = event.target.closest('.addCard_btn');

    if (!addButton) return;

    event.preventDefault();
    triggerQuickAdd(addButton);
  });

  window.triggerQuickAdd = triggerQuickAdd;
})();

(function () {
  function formatReviewScore(value) {
    const number = Number(value);
    if (!Number.isFinite(number) || number <= 0) return '';
    return number.toFixed(1);
  }

  function syncPdpRating(root) {
    const scope = root || document;
    const badge = document.querySelector('.jdgm-prev-badge[data-average-rating], .jdgm-prev-badge');
    if (!badge) return;

    const score = formatReviewScore(badge.dataset.averageRating);
    const count = badge.dataset.numberOfReviews || '';
    if (!score) return;

    scope.querySelectorAll('[data-pp-pdp-rating-score]').forEach(function (node) {
      node.textContent = score;
    });

    if (count) {
      scope.querySelectorAll('[data-pp-pdp-rating-count]').forEach(function (node) {
        node.textContent = count;
      });
    }
  }

  function getCartSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component'))
      .map(function (node) {
        return node.dataset.sectionId;
      })
      .filter(Boolean);
  }

  function dispatchCartUpdate(cart, sections, variantId, source) {
    const updateSource = source || 'pp-pdp-conversion';
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: updateSource,
        data: {
          source: updateSource,
          itemCount: cart.item_count || 0,
          variantId: variantId,
          sections: sections || {}
        }
      }
    }));
  }

  function setPdpStickyAtcVisible(stickyBar, isVisible) {
    const stickyButton = stickyBar.querySelector('[data-pp-sticky-atc]');

    stickyBar.classList.toggle('is-visible', isVisible);
    stickyBar.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    stickyBar.toggleAttribute('inert', !isVisible);

    if (!stickyButton) return;

    if (isVisible) {
      stickyButton.removeAttribute('tabindex');
    } else {
      stickyButton.setAttribute('tabindex', '-1');
    }
  }

  function initPdpStickyAtc() {
    const stickyBar = document.querySelector('main[data-template^="product"] [data-pp-pdp-sticky-bar]');
    const purchaseControls = document.querySelector('main[data-template^="product"] .product-details .buy-buttons-block');

    if (!stickyBar || !purchaseControls || stickyBar.dataset.ppPdpStickyReady === 'true') return;

    stickyBar.dataset.ppPdpStickyReady = 'true';

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const syncVisibility = function (rect) {
      const purchaseControlsHavePassed = rect.bottom <= 0;
      setPdpStickyAtcVisible(stickyBar, mobileQuery.matches && purchaseControlsHavePassed);
    };
    const syncFromLayout = function () {
      syncVisibility(purchaseControls.getBoundingClientRect());
    };

    setPdpStickyAtcVisible(stickyBar, false);

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries) {
        const entry = entries[0];
        if (!entry) return;
        syncVisibility(entry.boundingClientRect);
      }, { threshold: [0, 1] });

      observer.observe(purchaseControls);
    } else {
      let framePending = false;
      window.addEventListener('scroll', function () {
        if (framePending) return;
        framePending = true;

        window.requestAnimationFrame(function () {
          syncFromLayout();
          framePending = false;
        });
      }, { passive: true });
    }

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', syncFromLayout);
    } else {
      mobileQuery.addListener(syncFromLayout);
    }

    window.requestAnimationFrame(syncFromLayout);
  }

  function initPdpConversion(root) {
    syncPdpRating(root);

    const scope = root || document;
    const conversion = scope.querySelector?.('.pp-pdp-conversion') || document.querySelector('.pp-pdp-conversion');
    const buyButtons = document.querySelector('main[data-template^="product"] .product-details .buy-buttons-block');

    if (conversion && buyButtons && conversion.dataset.ppPdpPlaced !== 'true') {
      buyButtons.insertAdjacentElement('afterend', conversion);
      conversion.dataset.ppPdpPlaced = 'true';
    }

    initPdpStickyAtc();
  }

  function getPrimaryPdpPriceScope(event) {
    const source = event.target instanceof Element ? event.target : null;
    const productInformation = source?.closest('.product-information');

    // Ignore recommendations, product cards and the global quick-add dialog.
    if (!productInformation || source.closest('product-card, quick-add-dialog')) return null;

    const main = productInformation.closest('main[data-template^="product"]');
    if (!main) return null;

    const sourceProductId =
      event.detail?.data?.newProduct?.id ||
      event.detail?.data?.productId ||
      source.closest('[data-product-id]')?.dataset.productId;
    const primaryProductId =
      productInformation.dataset.productId ||
      productInformation.querySelector('product-form-component[data-product-id]')?.dataset.productId;

    if (sourceProductId && primaryProductId && String(sourceProductId) !== String(primaryProductId)) return null;

    return productInformation;
  }

  function syncSupplementalPdpPrice(scope, price, compareAtPrice, savings, showComparePrice) {
    if (!scope || !price) return;

    scope.querySelectorAll('[data-pp-sticky-price], [data-pp-mobile-price]').forEach(function (node) {
      node.textContent = price;
    });

    scope.querySelectorAll('[data-pp-mobile-compare-price]').forEach(function (node) {
      node.textContent = compareAtPrice || '';
      node.hidden = !(showComparePrice && compareAtPrice);
    });

    scope.querySelectorAll('[data-pp-mobile-savings]').forEach(function (node) {
      node.textContent = savings ? 'You save ' + savings : '';
      node.hidden = !(showComparePrice && savings);
    });
  }

  function syncPdpStickyAvailability(scope, available) {
    if (!scope || typeof available !== 'boolean') return;

    const stickyButton = scope.querySelector('[data-pp-sticky-atc]');
    if (!stickyButton) return;

    stickyButton.disabled = !available;
    stickyButton.classList.toggle('pp-sold-out-control', !available);
    stickyButton.textContent = available
      ? stickyButton.dataset.availableLabel || 'Add to cart'
      : stickyButton.dataset.soldOutLabel || 'Coming Soon';
  }

  document.addEventListener('click', function (event) {
    const couponButton = event.target.closest('[data-pp-copy-coupon]');
    if (couponButton) {
      const code = couponButton.dataset.ppCopyCoupon;
      if (!code) return;

      navigator.clipboard?.writeText(code).then(function () {
        const originalText = couponButton.textContent;
        couponButton.textContent = 'Copied';
        couponButton.classList.add('is-copied');
        window.setTimeout(function () {
          couponButton.textContent = originalText;
          couponButton.classList.remove('is-copied');
        }, 1600);
      });
      return;
    }

    const stickyButton = event.target.closest('[data-pp-sticky-atc]');
    if (stickyButton) {
      const atcButton = document.querySelector('main[data-template^="product"] .product-details .add-to-cart-button:not([disabled])');
      if (atcButton) {
        atcButton.click();
      } else {
        document.querySelector('main[data-template^="product"] .product-details')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    const promiseButton = event.target.closest('[data-pp-promise-product-cta]');
    if (promiseButton) {
      document
        .querySelector('main[data-template^="product"] .product-details')
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    const addOnButton = event.target.closest('[data-pp-fbt-add]');
    if (!addOnButton || addOnButton.disabled) return;

    const variantId = addOnButton.dataset.variantId;
    if (!variantId) return;

    const originalText = addOnButton.textContent;
    const formData = new FormData();
    const sectionIds = getCartSectionIds();
    const isCartAddon = addOnButton.hasAttribute('data-pp-cart-addon');
    const recommendation = addOnButton.closest('cart-recommendations');
    const status = recommendation?.querySelector('[data-cart-recommendation-status]');
    const productTitle = addOnButton.closest('.pp-cart-recommendation')?.querySelector('.pp-cart-recommendation__details a')?.textContent?.trim();

    addOnButton.disabled = true;
    addOnButton.textContent = 'Adding';
    addOnButton.setAttribute('aria-busy', 'true');
    recommendation?.setAttribute('aria-busy', 'true');
    if (status) {
      status.textContent = '';
      delete status.dataset.state;
    }

    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (sectionIds.length) {
      formData.append('sections', sectionIds.join(','));
    }

    const addTask = function () {
      return fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json'
        }
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || data.status) {
              throw new Error(data.description || data.message || 'Could not add item.');
            }
            return data;
          });
        })
        .then(function (response) {
          return fetch(Theme.routes.cart_url + '.json').then(function (cartResponse) {
            if (!cartResponse.ok) throw new Error('Could not refresh the cart.');
            return cartResponse.json().then(function (cart) {
              dispatchCartUpdate(cart, response.sections, variantId, isCartAddon ? 'cart-recommendation' : 'pp-pdp-conversion');
              return cart;
            });
          });
        });
    };

    const addPromise = window.PPCartMutations?.enqueue
      ? window.PPCartMutations.enqueue(addTask)
      : addTask();

    addPromise
      .then(function () {
        addOnButton.textContent = 'Added';
        addOnButton.classList.add('is-added');
        if (status) {
          status.textContent = (productTitle || 'Item') + ' added to your cart.';
          status.dataset.state = 'success';
        }
        if (isCartAddon) {
          const detail = {
            event: 'pp_cart_recommendation_add',
            cart_device: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
            variant_id: variantId
          };
          window.dispatchEvent(new CustomEvent('cart:v2:analytics', { detail: detail }));
          if (Array.isArray(window.dataLayer)) window.dataLayer.push(detail);
        }
      })
      .catch(function () {
        addOnButton.textContent = 'Try again';
        if (status) {
          status.textContent = "We couldn't add that item. Please try again.";
          status.dataset.state = 'error';
        }
      })
      .finally(function () {
        addOnButton.removeAttribute('aria-busy');
        recommendation?.removeAttribute('aria-busy');
        window.setTimeout(function () {
          addOnButton.disabled = false;
          addOnButton.textContent = originalText;
          addOnButton.classList.remove('is-added');
        }, 1800);
      });
  });

  document.addEventListener('variant:update', function (event) {
    const priceScope = getPrimaryPdpPriceScope(event);
    if (!priceScope) return;

    syncPdpStickyAvailability(priceScope, event.detail?.resource?.available);

    const html = event.detail?.data?.html;
    if (!html) return;

    const newPrice = html
      .querySelector('.product-information product-price .price, .product-information .product-details .price')
      ?.textContent?.trim();
    if (!newPrice) return;

    const newCompareAtPrice =
      html.querySelector('.product-information product-price .compare-at-price')?.textContent?.trim() || '';
    const newSavings =
      html
        .querySelector('.product-information [data-pp-mobile-savings]')
        ?.textContent?.trim()
        .replace(/^You save\s+/i, '') || '';
    const showComparePrice = Boolean(newCompareAtPrice);

    syncSupplementalPdpPrice(priceScope, newPrice, newCompareAtPrice, newSavings, showComparePrice);
  });

  document.addEventListener('variant:selected', function (event) {
    const priceScope = getPrimaryPdpPriceScope(event);
    if (!priceScope) return;

    const variant = event.detail?.resource;
    syncPdpStickyAvailability(priceScope, variant?.available);
    if (!variant?.price) return;

    syncSupplementalPdpPrice(
      priceScope,
      variant.price,
      variant.compareAtPrice,
      variant.savings,
      variant.showComparePrice
    );
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPdpConversion();
    }, { once: true });
  } else {
    initPdpConversion();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initPdpConversion(event.target);
  });
})();

(function () {
  function getMainProductForm() {
    return document.querySelector('main[data-template^="product"] product-form-component form[action*="/cart/add"]');
  }

  function syncFastrrForm(button) {
    const fastrrForm = button?.closest('form');
    const productForm = getMainProductForm();

    if (!fastrrForm || !productForm) return fastrrForm;

    const sourceVariant = productForm.querySelector('input[name="id"]');
    const sourceQuantity = productForm.querySelector('input[name="quantity"]');
    const targetVariant = fastrrForm.querySelector('input[name="id"]');
    let targetQuantity = fastrrForm.querySelector('input[name="quantity"]');

    if (sourceVariant && targetVariant) {
      targetVariant.value = sourceVariant.value;
    }

    if (!targetQuantity) {
      targetQuantity = document.createElement('input');
      targetQuantity.type = 'hidden';
      targetQuantity.name = 'quantity';
      fastrrForm.appendChild(targetQuantity);
    }

    targetQuantity.value = sourceQuantity?.value || productForm.querySelector('quantity-selector-component input')?.value || '1';

    return fastrrForm;
  }

  function waitForFastrr(methodName) {
    const isReady = function () {
      return typeof window.shiprocketCheckoutEvents?.[methodName] === 'function';
    };

    if (isReady()) {
      return Promise.resolve(true);
    }

    const loader = window.ppLoadShiprocketCheckout?.();
    const startedAt = Date.now();

    return Promise.resolve(loader).then(function () {
      return new Promise(function (resolve) {
        const tick = function () {
          if (isReady()) {
            resolve(true);
            return;
          }

          if (Date.now() - startedAt > 5000) {
            resolve(false);
            return;
          }

          window.setTimeout(tick, 100);
        };

        tick();
      });
    });
  }

  const cartCheckoutSelector = '[data-pp-fastrr-cart-checkout]';
  const cartCheckoutTimeout = 4500;

  function trackCartCheckout(eventName, detail) {
    const payload = {
      event: eventName,
      cart_device: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
      ...(detail || {}),
    };

    window.dispatchEvent(new CustomEvent('cart:v2:analytics', { detail: payload }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
  }

  function getCartCheckoutStatus(button) {
    return button?.closest('.cart__checkout-panel')?.querySelector('[data-pp-checkout-status]') || null;
  }

  function setCartCheckoutState(button, state, message) {
    if (!button) return;

    const isPending = state === 'loading' || state === 'error';
    const status = getCartCheckoutStatus(button);

    button.disabled = isPending;
    button.classList.toggle('is-loading', isPending);
    button.setAttribute('aria-busy', isPending ? 'true' : 'false');

    if (!status) return;

    status.textContent = message || '';
    status.dataset.state = state;
    status.setAttribute('aria-live', state === 'error' ? 'assertive' : 'polite');
  }

  function getShopifyCheckoutUrl() {
    const root = window.Shopify?.routes?.root || '/';
    return root + (root.endsWith('/') ? '' : '/') + 'checkout';
  }

  function ensureNativeCartCheckoutInput(form) {
    let checkoutInput = form.querySelector('input[name="checkout"][data-pp-fallback-checkout]');

    if (!checkoutInput) {
      checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = 'checkout';
      checkoutInput.setAttribute('data-pp-fallback-checkout', '');
      form.appendChild(checkoutInput);
    }
  }

  function prepareNativeCartCheckout(form, button, reason) {
    if (!form || form.dataset.ppNativeCheckoutSubmitted === 'true') return false;

    form.dataset.ppNativeCheckoutSubmitted = 'true';
    ensureNativeCartCheckoutInput(form);
    setCartCheckoutState(button, 'loading', 'Opening Shopify checkout…');
    trackCartCheckout('pp_cart_checkout_provider', { provider: 'shopify', reason });
    trackCartCheckout('pp_cart_checkout_fallback', { reason });
    return true;
  }

  function fallbackToShopifyCartCheckout(button, reason, delay) {
    const form = button?.form || document.getElementById('cart-form');

    if (!form) {
      trackCartCheckout('pp_cart_checkout_fallback', { reason: reason || 'missing_cart_form' });
      window.location.assign(getShopifyCheckoutUrl());
      return;
    }

    if (!prepareNativeCartCheckout(form, button, reason || 'provider_unavailable')) return;

    window.setTimeout(function () {
      HTMLFormElement.prototype.submit.call(form);
    }, delay || 0);
  }

  function isFastrrCartCheckoutOpen() {
    const container = document.getElementById('fastrr-main-container');
    return Boolean(container && !container.hidden && container.getAttribute('aria-hidden') !== 'true');
  }

  function waitForFastrrCartHandoff(providerResult) {
    return new Promise(function (resolve) {
      let settled = false;
      let observer = null;
      let timeout = null;

      const finish = function (ok, reason) {
        if (settled) return;
        settled = true;
        observer?.disconnect();
        if (timeout) window.clearTimeout(timeout);
        window.removeEventListener('pagehide', handlePageHide);
        resolve({ ok, reason });
      };

      const handlePageHide = function () {
        finish(true, 'navigation');
      };

      if (isFastrrCartCheckoutOpen()) {
        finish(true, 'container');
        return;
      }

      observer = new MutationObserver(function () {
        if (isFastrrCartCheckoutOpen()) finish(true, 'container');
      });
      observer.observe(document.body, { childList: true, subtree: true, attributes: true });
      window.addEventListener('pagehide', handlePageHide, { once: true });

      timeout = window.setTimeout(function () {
        finish(document.visibilityState === 'hidden', 'timeout');
      }, cartCheckoutTimeout);

      if (providerResult && typeof providerResult.then === 'function') {
        Promise.resolve(providerResult).then(function (value) {
          if (value === false) finish(false, 'provider_declined');
        }).catch(function () {
          finish(false, 'provider_rejected');
        });
      } else if (providerResult === false) {
        finish(false, 'provider_declined');
      }
    });
  }

  function settleFastrrCartCheckout(button, succeeded, reason) {
    window.dispatchEvent(new CustomEvent('pp:shiprocket-checkout-settled', {
      detail: { succeeded, reason },
    }));

    if (succeeded) {
      setCartCheckoutState(button, 'idle', 'Secure checkout opened.');
      window.setTimeout(function () {
        setCartCheckoutState(button, 'idle', '');
        delete button.dataset.ppCheckoutPending;
      }, 1800);
      return;
    }

    trackCartCheckout('pp_cart_checkout_failure', { provider: 'shiprocket', reason });
    setCartCheckoutState(button, 'error', 'Payment window unavailable. Continuing to checkout…');
    window.setTimeout(function () {
      fallbackToShopifyCartCheckout(button, reason);
    }, 450);
  }

  function fallbackToShopifyCheckout(form) {
    const variantId = form?.querySelector('input[name="id"]')?.value;
    const quantity = form?.querySelector('input[name="quantity"]')?.value || '1';

    if (!variantId) {
      window.location.href = '/cart';
      return;
    }

    fetch('/cart/clear.js', { method: 'POST' })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }] }),
        });
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function () {
        window.location.href = '/cart/' + encodeURIComponent(variantId) + ':' + encodeURIComponent(quantity);
      });
  }

  window.ppHandleFastrrBuyNow = function (event) {
    event.preventDefault();
    event.stopPropagation();

    const button = event.currentTarget;
    const form = syncFastrrForm(button);

    button.disabled = true;
    button.classList.add('is-loading');

    waitForFastrr('buyProduct').then(function (isReady) {
      if (isReady && window.shiprocketCheckoutEvents?.buyProduct) {
        window.shiprocketCheckoutEvents.buyProduct({
          currentTarget: button,
          target: button,
          preventDefault: function () {},
          stopPropagation: function () {},
        });
        return;
      }

      fallbackToShopifyCheckout(form);
    }).finally(function () {
      window.setTimeout(function () {
        button.disabled = false;
        button.classList.remove('is-loading');
      }, 1800);
    });
  };

  window.ppHandleFastrrCartCheckout = function (event) {
    const button = event.currentTarget;
    const provider = window.shiprocketCheckoutEvents?.buyCart;

    if (!button || button.dataset.ppCheckoutPending === 'true') {
      event.preventDefault();
      return false;
    }

    button.dataset.ppCheckoutTracked = 'true';
    trackCartCheckout('pp_cart_checkout_click', {
      cart_total: button.querySelector('[data-pp-checkout-label]')?.textContent?.trim() || '',
    });

    if (typeof provider !== 'function') {
      button.dataset.ppCheckoutNativeReason = 'provider_not_ready';
      window.ppLoadShiprocketCheckout?.();
      return true;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    button.dataset.ppCheckoutPending = 'true';
    setCartCheckoutState(button, 'loading', 'Opening secure checkout…');
    trackCartCheckout('pp_cart_checkout_provider', { provider: 'shiprocket' });
    window.dispatchEvent(new CustomEvent('pp:shiprocket-checkout-start'));

    let providerResult;
    try {
      providerResult = provider.call(window.shiprocketCheckoutEvents, event);
    } catch {
      settleFastrrCartCheckout(button, false, 'provider_exception');
      return false;
    }

    waitForFastrrCartHandoff(providerResult).then(function (result) {
      settleFastrrCartCheckout(button, result.ok, result.reason);
    });

    return false;
  };

  document.addEventListener('submit', function (event) {
    const form = event.target;
    const button = event.submitter?.matches?.(cartCheckoutSelector)
      ? event.submitter
      : null;

    if (!(form instanceof HTMLFormElement) || form.id !== 'cart-form' || !button) return;

    if (form.dataset.ppNativeCheckoutSubmitted === 'true') {
      event.preventDefault();
      return;
    }

    if (button.dataset.ppCheckoutTracked !== 'true') {
      trackCartCheckout('pp_cart_checkout_click', {
        cart_total: button.querySelector('[data-pp-checkout-label]')?.textContent?.trim() || '',
      });
    }

    prepareNativeCartCheckout(
      form,
      button,
      button.dataset.ppCheckoutNativeReason || 'native_checkout'
    );
  }, true);

  document.addEventListener('variant:update', function (event) {
    if (!event.detail?.resource?.id) return;

    document.querySelectorAll('[data-pp-fastrr-buy-now]').forEach(function (button) {
      const form = button.closest('form');
      const variantInput = form?.querySelector('input[name="id"]');

      if (variantInput) {
        variantInput.value = event.detail.resource.id;
      }

      if (event.detail.resource.available === false) {
        button.disabled = true;
      } else {
        button.disabled = false;
      }
    });
  });
})();

(function () {
  const revealSelector = [
    '.pp-front-proof article',
    '.pp-front-mind__item',
    '.pp-front-concern-tile',
    '.pp-front-summer-edit__copy',
    '.pp-front-summer-tile',
    '.pp-front-ritual',
    '.pp-front-card',
    '.pp-front-story',
    '.pp-front-routine article',
    '.pp-front-review-card',
    '.pp-front-journal-card',
    '[data-template="collection"] .product-grid__item',
    '[data-template="search"] .product-grid__item',
    'main[data-template^="product"] .product-information__media',
    'main[data-template^="product"] .product-details',
    'main[data-template^="product"] .tab-section',
    'main[data-template^="product"] .faq-section',
    'footer .group-block'
  ].join(',');

  function initSummerReveals(root) {
    const scope = root || document;
    const nodes = Array.from(scope.querySelectorAll(revealSelector)).filter(function (node) {
      return !node.dataset.ppRevealReady;
    });

    if (!nodes.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    nodes.forEach(function (node, index) {
      node.dataset.ppRevealReady = 'true';
      node.dataset.ppRevealDelay = String(index % 4);
      node.classList.add('pp-reveal');

      if (prefersReducedMotion) {
        node.classList.add('is-visible');
      }
    });

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (node) {
        node.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver(function (entries, instance) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('is-visible');
        instance.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.14
    });

    nodes.forEach(function (node) {
      observer.observe(node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.ppRunWhenIdle(initSummerReveals, 1200);
    }, { once: true });
  } else {
    window.ppRunWhenIdle(initSummerReveals, 1200);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSummerReveals(event.target);
  });
})();

(function () {
  function initMindRail(root) {
    const scope = root || document;

    scope.querySelectorAll('.pp-front-mind').forEach(function (section) {
      if (section.dataset.ppMindReady === 'true') return;

      const rail = section.querySelector('[data-pp-mind-rail]');
      const prev = section.querySelector('[data-pp-mind-prev]');
      const next = section.querySelector('[data-pp-mind-next]');

      if (!rail || !prev || !next) return;

      section.dataset.ppMindReady = 'true';

      function getStep() {
        const firstItem = rail.querySelector('.pp-front-mind__item');
        if (!firstItem) return rail.clientWidth * 0.75;

        const styles = window.getComputedStyle(rail);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return firstItem.getBoundingClientRect().width + gap;
      }

      function updateButtons() {
        const maxLeft = rail.scrollWidth - rail.clientWidth - 4;
        prev.disabled = rail.scrollLeft <= 4;
        next.disabled = rail.scrollLeft >= maxLeft;
      }

      prev.addEventListener('click', function () {
        rail.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      next.addEventListener('click', function () {
        rail.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      rail.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.ppRunWhenIdle(initMindRail, 1600);
    }, { once: true });
  } else {
    window.ppRunWhenIdle(initMindRail, 1600);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initMindRail(event.target);
  });
})();

(function () {
  const searchPlaceholder = 'Search products';

  function setSearchSuggestion(element, text) {
    if (element.matches('input, textarea')) {
      element.placeholder = text;
      return;
    }

    element.dataset.ppSearchPlaceholderText = text;
  }

  function initSearchPlaceholders(root) {
    const scope = root || document;

    scope.querySelectorAll('[data-pp-search-placeholder], [data-pp-search-placeholder-trigger]').forEach(function (element) {
      if (element.dataset.ppSearchPlaceholderReady === 'true') return;

      element.dataset.ppSearchPlaceholderReady = 'true';
      setSearchSuggestion(element, searchPlaceholder);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSearchPlaceholders(document);
    }, { once: true });
  } else {
    initSearchPlaceholders(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSearchPlaceholders(event.target);
  });
})();

(function () {
  const styleId = 'pp-mobile-chat-offset';

  function syncShopifyChatOffset() {
    const host = document.querySelector('shopify-agent');
    if (!host) return false;

    host.toggleAttribute('data-pp-product-page', Boolean(document.querySelector('main[data-template^="product"]')));

    const shadowRoot = host.shadowRoot;
    if (!shadowRoot) return false;
    if (shadowRoot.getElementById(styleId)) return true;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = [
      '@media (max-width: 749px) {',
      '  .activator-nudge { bottom: 72px !important; }',
      '  :host([data-pp-product-page]) .activator-nudge { bottom: 82px !important; }',
      '}'
    ].join('\n');
    shadowRoot.appendChild(style);
    return true;
  }

  function initShopifyChatOffset() {
    if (syncShopifyChatOffset()) return;

    const observer = new MutationObserver(function () {
      if (!syncShopifyChatOffset()) return;
      observer.disconnect();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      syncShopifyChatOffset();
      observer.disconnect();
    }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShopifyChatOffset, { once: true });
  } else {
    initShopifyChatOffset();
  }
})();
